module.exports = __webpack_public_path__ + "media/images/mclaren-542885f629d9f563f5f54c7fda177b39.png";